/** Knockout round IDs and display names, ordered by progression (ascending round ID). */
export const KNOCKOUT_ROUNDS = [
  { id: 9, label: "Round of 32" },
  { id: 10, label: "Round of 16" },
  { id: 11, label: "Quarter-Finals" },
  { id: 12, label: "Semi-Finals" },
  { id: 14, label: "Third Place Playoff" },
  { id: 13, label: "Final" },
] as const;

export const GROUP_STAGE_ROUND_ID = 8;

/** Start of 2026-07-20 UTC — the moment after the World Cup final. */
export const WORLD_CUP_END_TIMESTAMP_MS = Date.UTC(2026, 6, 20);
